import { CanMatchFn, Route } from '@angular/router';
import { inject } from '@angular/core';
import { catchError, map, of } from 'rxjs';
import { ToggleApiService } from '../toggle/toggle-api.service';

export const featureToggleGuard: CanMatchFn = (route: Route) => {
  const toggleApiService = inject(ToggleApiService);
  const featureToggleKey = route.data?.routeItem?.featureToggleKey ?? null;

  if (!featureToggleKey) {
    return of(true);
  }

  return toggleApiService.isEnabled(featureToggleKey).pipe(
    map(featureToggleDto => featureToggleDto.enabled),
    catchError(() => of(false))
  );
};
